import React from 'react'
import SALink from 'components/SALink'
import { InfoRow, OwnerInfoSection, OwnerAvatar, CuratorName } from '../styles'
import {
  DEFAULT_AVATAR_IMAGE_URL,
  VIEW_PROFILE_TOOLTIP,
  DEFAULT_CURATOR_TITLE,
} from '../../helpers/constants'

type Props = {
  curatorUserId: number
  avatarUrl?: string
  curatorName?: string
  jobTitle?: string
  curatorNameDataType?: string
  avatarDataType?: string
  curatorJobDataType?: string
  curatorSectionDataType?: string
}
export default (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    curatorUserId,
    avatarUrl,
    curatorName,
    jobTitle,
    curatorNameDataType,
    curatorJobDataType,
    avatarDataType,
    curatorSectionDataType,
  } = props
  const curatorAvatar = avatarUrl ? `${avatarUrl}` : DEFAULT_AVATAR_IMAGE_URL
  const curatorJobTitle = jobTitle || DEFAULT_CURATOR_TITLE
  const curatorProfileURL = `/account/profile/${curatorUserId}`
  return (
    <OwnerInfoSection data-type={curatorSectionDataType}>
      <InfoRow>
        <SALink href={curatorProfileURL} title={VIEW_PROFILE_TOOLTIP}>
          <OwnerAvatar
            data-type={avatarDataType}
            src={curatorAvatar}
            alt={curatorName}
            width='44px'
            height='44px'
          />
        </SALink>
        <div data-type={curatorNameDataType} data-style='curator-info-text-container'>
          <CuratorName href={curatorProfileURL} title={VIEW_PROFILE_TOOLTIP}>
            <h6 className='defaultTypographyH6'>Curated by {curatorName}</h6>
          </CuratorName>
          <p className='defaultTypographyXSmall' data-type={curatorJobDataType}>
            {curatorJobTitle}
          </p>
        </div>
      </InfoRow>
    </OwnerInfoSection>
  )
}
